import { getFeatureFlag, isValidUrl } from "@sinch/feature-flags";

const MCP_PROD_BASE_URL = "https://rest.messengerpeople.com";
const MM_PROD_BASE_URL = "https://api.messagemedia.com/middleware";
const MM_NEXTGEN_PROD_BASE_URL = "https://api.messagemedia.com";

export const getMessageMediaApiUrlMiddleware = () =>
  getFeatureFlag("messageMediaApiUrlMiddleware", isValidUrl, MM_PROD_BASE_URL);

export const getMessageMediaApiUrl = () =>
  getFeatureFlag("messageMediaApiUrl", isValidUrl, MM_NEXTGEN_PROD_BASE_URL);

export const getMcpApiBaseUrl = () =>
  getFeatureFlag("mcpApiBaseUrl", isValidUrl, MCP_PROD_BASE_URL);
